/**
 * Check if environment is production
 * 
 * @param env current sensory link environment
 * @returns isProd
 */
export function isProd(env: SensoryLinkEnvironment): boolean {
  if (isAzure(env)) {
    return env === "production_azure"
  }
  return env === "production";
}

/**
 * Check if environment is staging
 * 
 * @param env current sensory link environment
 * @returns isStaging
 */
export function isStaging(env: SensoryLinkEnvironment): boolean {
  if (isAzure(env)) {
    return env === "pre4azure"
  }
  return env === "staging";
}

/**
 * Checks if the GraphQLInterface service is running in an Azure environment.
 * @param env The environment of GraphQLInterface, which is our proxy to the environment of SensoryLink.
 * @returns 
 */
export function isAzure(env: SensoryLinkEnvironment): boolean {
  return (env === "development_azure") || (env === "production_azure") || (env === "pre4azure")
}